import React from 'react';
import '../../styles/mainContents.css';
import { setRotatesOutOfStockBatteryState, setRotatesState  } from '../../redux/actions/PostActions';
import { connect } from 'react-redux';

function RotatesTable(props) {

  const { print, set_rotatesOutOfStockBatteryState, set_rotatesState, clickedInvno, rotatesState, rotateInvoiceOutOfStockBatteryState } = props;
  // console.log('rotatesState',rotatesState)
  // console.log('rotateInvoiceOutOfStockBatteryState',rotateInvoiceOutOfStockBatteryState)

  let RotatesTr = (state, outOfStock=false) => {

    // console.log('RotatesTable RotatesTr rotatesState', rotatesState, clickedInvno) 
    
    return state.map(function(v, i){
      let keyId = ((state[i]['ID'] === undefined) ? 0 : v['ID'])

      // console.log('RotatesTable RotatesTr v', v) 
      // console.log('RotatesTable RotatesTr i', i)
      // console.log('RotatesTable RotatesTr keyId', keyId)

      return (
        <tr key={'rotatesTr-'+ keyId + '-' + i}>
          <td>
            {state[i]['PARTNO']}
          </td>  

          <td>
            { print !== true ? 
              <>          
                <select id={'iRotatesRotateCode-' + keyId} 
                  onChange={(e) => {
                    const updatedRotatesState = state.map((item, index) => {
                      if (index === i) {
                        return {
                          ...item,
                          ROTATE_CODE: e.target.value,
                        };
                      }
                      return item;
                    });

                    if(outOfStock === false){
                      set_rotatesState(updatedRotatesState);
                    }
                    else{
                      set_rotatesOutOfStockBatteryState(updatedRotatesState);
                    }
                                    
                  }} 
                  value={state[i]['ROTATE_CODE']}             
                >
                  <option value=""></option>
                  {
                    outOfStock === false ? <option value="Completed">Completed</option> : <option value="Re-Request">Re-Request</option> 
                  }
                  
                  <option value="Cancelled">Cancelled</option>
                </select> 
              </>
              :
              <>
                <input 
                  id={'iRotatesRotateCode-' + keyId}
                  className={'userInputField'}
                  type='text' 
                  name='nRotatesRotateCode' 
                  defaultValue={''}                   
                /> 
              </>

                
            }
          </td>  

          <td>
            <input 
              id={'iRotatesVoltage-' + keyId}
              className={'userInputField'}
              type='number' 
              name='nRotatesVoltage' 
              defaultValue={''}                   
              onChange={(e) => {
                console.log('iRotatesVoltage keyId', keyId)
                const updatedRotatesState = state.map((item, index) => {
                  if (index === i) {
                    return {
                      ...item,
                      VOLTAGE: e.target.value,
                    };
                  }
                  return item;
                });

                if(outOfStock === false){
                  set_rotatesState(updatedRotatesState);
                }
                else{
                  set_rotatesOutOfStockBatteryState(updatedRotatesState);
                }
              }
              }
            />                      
          </td>  

          <td>
            <input 
              id={'iRotatesDateCode-' + keyId}
              className={'userInputField'}
              type='text' 
              name='nRotatesDateCode' 
              defaultValue={''}                   
              onChange={(e) => {
                const updatedRotatesState = state.map((item, index) => {
                  if (index === i) {
                    return {
                      ...item,
                      DATECODE: e.target.value,
                    };
                  }
                  return item;
                });
                
                if(outOfStock === false){
                  set_rotatesState(updatedRotatesState);
                }
                else{
                  set_rotatesOutOfStockBatteryState(updatedRotatesState);
                }


              }
              }
            />                      
          </td> 
                                                             
        </tr>    
          
      )
    });

  
  }

  let RotatesTrPrint = (state) => {

    return state.map(function(v, i){

      let keyId = ((state[i]['ID'] === undefined) ? 0 : v['ID'])
      console.log(' keyId', keyId)


      return (
        <tr key={'rotatesTr-'+ keyId}>
          <td> 
            {state[i]['PARTNO']}
          </td> 

          <td>
            <input 
                id={'iRotatesVoltage-' + keyId}
                className={'userInputField'}
                type='number' 
                name='nRotatesVoltage' 
                defaultValue={''}                   
              />              
          </td> 

          <td>
          </td> 

          <td>
          </td> 

          <td>
          </td>   

        </tr> 
      )
    });

  
  }

  return (

    <div>
    
      <table id='rotatesTblId'>
        <thead>
          <tr>  
            <th>Partno</th>
            <th>Rotate Result</th>
            {/* <th>Rotate Reason</th> */}
            <th>Voltage</th>
            <th>Date Code</th>
            <th></th>

          </tr>
        </thead>
        { 
          <tbody id='rotateRequestDataTable_body'> 
            {RotatesTr(rotatesState, false)}                
          </tbody>
        }
      </table>

      {
        rotateInvoiceOutOfStockBatteryState !== undefined && rotateInvoiceOutOfStockBatteryState.length > 0 ?
        <div>
          <p>
          Parts below did not have enough stock to rotate.
          <br/>
          Select whether the rotates should be requested again or cancelled if 
          <br/>
          the battery is no longer present at the customer to rotate.
          </p>

          <table id='rotatesOutOfStockBatteryTblId'>
            <thead>
              <tr>  
                <th>Partno</th>
                <th>Rotate Result</th>
                {/* <th>Rotate Reason</th> */}
                <th>Voltage</th>
                <th>Date Code</th>
                <th></th>
              </tr>
            </thead>
            { 
            <tbody id='rotatesOutOfStockBatteryDataTable_body'>         
              {RotatesTr(rotateInvoiceOutOfStockBatteryState, true)}
            </tbody>
            }
          </table>
        </div>
        : ''
      }        

    </div>

  );
}



const mapStateToProps = (state) => {
 return {
  authreducerState: state.authreducer,
  rotatesState: state.rotatesReducer['items_rotatesState'],
  rotateInvoiceOutOfStockBatteryState: state.rotatesReducer['items_rotateInvoiceOutOfStockBatteryState']
 }
};

const mapDispatchToProps = (dispatch) => {
  return {      
    set_rotatesState: (row) => {
      dispatch(setRotatesState(row));
    },  
    set_rotatesOutOfStockBatteryState: (row) => {
      dispatch(setRotatesOutOfStockBatteryState(row));
    },     
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RotatesTable);